
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserInvitationData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitationCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserInvitationData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"invitationCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitationCode"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiative"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"class"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coverMedia"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileInstanceFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"gatherUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeTypeFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relationship"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationshipFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"targetEntityType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetPubliclyJoinable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetRoleId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userFirstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userHasAccount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userIsActiveCommunityMember"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userLastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userOtherActiveCommunities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"host"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":839}};
    doc.loc.source = {"body":"#import '../fragments/FileInstance.gql'\n#import '../fragments/InitiativeType.gql'\n#import '../fragments/Relationship.gql'\n\nquery getUserInvitationData($userEmail: String!, $invitationCode: String!) {\n   getUserInvitationData(userEmail: $userEmail, invitationCode: $invitationCode) {\n      initiative {\n         id\n         class\n         coverMedia {\n            ...FileInstanceFragment\n         }\n         gatherUrl\n         name\n         subtitle\n         type {\n            ...InitiativeTypeFragment\n         }\n      }\n      relationship {\n         ...RelationshipFragment\n      }\n      targetEntityType\n      targetPubliclyJoinable\n      targetRoleId\n      userFirstName\n      userHasAccount\n      userIsActiveCommunityMember\n      userLastName\n      userOtherActiveCommunities {\n         id\n         name\n         host\n      }\n   }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('../fragments/FileInstance.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/InitiativeType.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/Relationship.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getUserInvitationData"] = oneQuery(doc, "getUserInvitationData");
        
